module.exports = __webpack_public_path__ + "img/advil_pm_caplets.2efa30e7.png";